export const POPULAR_THEMES = [
  {
    name: "Graceful",
    value: "https://github.com/discourse/graceful",
    preview:
      "https://discourse.theme-creator.io/theme/Discourse/graceful-theme",
    screenshot_url:
      "https://github.com/discourse/graceful/blob/main/screenshots/light.png?raw=true",
    description: "A light and graceful theme for Discourse.",
    meta_url: "https://meta.discourse.org/t/graceful-theme/93040",
  },
  {
    name: "Material Design Theme",
    value: "https://github.com/discourse/material-design-stock-theme",
    preview:
      "https://discourse.theme-creator.io/theme/Discourse/material-design-theme",
    screenshot_url:
      "https://github.com/discourse/material-design-stock-theme/blob/main/screenshots/light.png?raw=true",
    description:
      "Inspired by Material Design, this theme comes with several color palettes.",
    meta_url: "https://meta.discourse.org/t/material-design-theme/47142",
  },
  {
    name: "Mint",
    value: "https://github.com/discourse/discourse-mint-theme",
    preview: "https://discourse.theme-creator.io/theme/Discourse/mint-theme",
    screenshot_url:
      "https://github.com/discourse/discourse-mint-theme/blob/main/screenshots/light.webp?raw=true",
    description:
      "A minty colored theme with featured homepage categories and a search banner.",
    meta_url: "https://meta.discourse.org/t/mint-theme/202822",
  },
  {
    name: "Sam's Simple Theme",
    value: "https://github.com/discourse/discourse-simple-theme",
    preview:
      "https://discourse.theme-creator.io/theme/Discourse/sams-simple-theme",
    screenshot_url:
      "https://github.com/discourse/discourse-simple-theme/blob/main/screenshots/light.png?raw=true",
    description:
      "Simplified front page design with classic colors and typography.",
    meta_url: "https://meta.discourse.org/t/sams-simple-theme/23552",
  },
  {
    name: "Brand Header",
    value: "https://github.com/discourse/discourse-brand-header",
    preview: "https://discourse.theme-creator.io/theme/Discourse/brand-header",
    description:
      "Add an extra top header with your logo, navigation links and social icons.",
    meta_url: "https://meta.discourse.org/t/brand-header/77977",
    component: true,
  },
  {
    name: "Custom Header Links",
    value: "https://github.com/discourse/discourse-custom-header-links",
    preview:
      "https://discourse.theme-creator.io/theme/Discourse/custom-header-links",
    description: "Easily add custom text-based links to the header.",
    meta_url: "https://meta.discourse.org/t/custom-header-links/90588",
    component: true,
  },
  {
    name: "Discourse GIFS",
    value: "https://github.com/discourse/discourse-gifs",
    description: "Adds a button to easily search and insert GIFs in posts.",
    meta_url: "https://meta.discourse.org/t/discourse-gifs/158738",
    component: true,
  },
  {
    name: "Category Banners",
    value: "https://github.com/discourse/discourse-category-banners",
    preview:
      "https://discourse.theme-creator.io/theme/Discourse/category-banners",
    description:
      "Show banners on category pages using your existing category details.",
    meta_url: "https://meta.discourse.org/t/category-banners/86241",
    component: true,
  },
  {
    name: "Tag Banners",
    value: "https://github.com/discourse/discourse-tag-banners",
    preview: "https://discourse.theme-creator.io/theme/Discourse/tag-banners",
    description: "Show banners on tag pages using your existing tag details.",
    meta_url: "https://meta.discourse.org/t/tag-banners/124240",
    component: true,
  },
  {
    name: "Kanban Board",
    value: "https://github.com/discourse/discourse-kanban-theme",
    preview: "https://discourse.theme-creator.io/theme/Discourse/kanban-board",
    description: "Display and organize topics using a Kanban board interface.",
    meta_url: "https://meta.discourse.org/t/kanban-board/118164",
    component: true,
  },
  {
    name: "Sidebar Theme Toggle",
    value: "https://github.com/discourse/discourse-sidebar-theme-toggle",
    description:
      "Displays a theme selector in the sidebar menu’s footer provided there is more than one user-selectable theme.",
    meta_url: "https://meta.discourse.org/t/sidebar-theme-toggle/242802",
    component: true,
  },
  {
    name: "Header Submenus",
    value: "https://github.com/discourse/discourse-header-submenus",
    preview:
      "https://discourse.theme-creator.io/theme/Discourse/header-submenus",
    description: "Lets you build a header menu with submenus (dropdowns).",
    meta_url: "https://meta.discourse.org/t/header-submenus/94584",
    component: true,
  },
  {
    name: "Automatic Table of Contents",
    value: "https://github.com/discourse/DiscoTOC",
    preview: "https://discourse.theme-creator.io/theme/Discourse/discotoc",
    description:
      "Generates an interactive table of contents on the sidebar of your topic with a simple click in the composer.",
    meta_url:
      "https://meta.discourse.org/t/discotoc-automatic-table-of-contents/111143",
    component: true,
  },
  {
    name: "Easy Responsive Footer",
    value: "https://github.com/discourse/Discourse-easy-footer",
    preview:
      "https://discourse.theme-creator.io/theme/Discourse/easy-responsive-footer",
    description: "Add a fully responsive footer without writing any HTML.",
    meta_url: "https://meta.discourse.org/t/easy-responsive-footer/95818",
    component: true,
  },
];

export function descriptionForRemoteUrl(url) {
  url = url.replace(/\.git$/, "");
  return POPULAR_THEMES.find((obj) => obj.value === url)?.description;
}
